var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('div',{style:({ marginTop: _vm.marginTop })},[_c('router-view')],1),_c('Footer'),_c('Alert'),_c('Message')],1)}
var staticRenderFns = []

export { render, staticRenderFns }